function ThankYouPage() {
  return (
    <div style={{
      backgroundColor: '#ECF2F6',
      Height: '100vh',
      display: 'flex',
      alignItems: 'center',
    }}>
      <div style={{
        width: '100%',
        maxWidth: '800px',
        margin: '0 auto',
        padding: '30px'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '10px',
          padding: '30px',
          boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
          textAlign: 'center',
          borderLeft: '5px solid #27568B',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '5px',
            background: '#27568B',
          }}></div>
          
          <h4 style={{
            color: '#27568B',
            marginBottom: '8px',
            fontWeight: '600'
          }}>Thank You for Your Feedback!</h4>
        </div>
      </div>
    </div>
  );
}

export default ThankYouPage;